export const stopsCount = ['Non-Stop', 'One-Stop', 'Two-Stop', 'Three-Stop', 'Four-Stop', 'Five-Stop', 'Six-Stop']

export const title = ['', 'Mr', 'Ms', 'Miss', '', 'Mrs', 'Mstr']
